import { render, staticRenderFns } from "./AdminFieldRelated.vue?vue&type=template&id=19bd9903&"
import script from "./AdminFieldRelated.vue?vue&type=script&lang=js&"
export * from "./AdminFieldRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports